(function() {
  'use strict';

  var GUEST_KEY = 'babytoms_wishlist_guest';

  // Get active storage key (customer-scoped or guest)
  function getStorageKey() {
    if (window.ShopifyCustomer && window.ShopifyCustomer.id) {
      return 'babytoms_wishlist_customer_' + window.ShopifyCustomer.id;
    }
    return GUEST_KEY;
  }

  // Migrate guest wishlist items to logged-in customer wishlist if user just logged in
  function migrateGuestWishlist() {
    if (window.ShopifyCustomer && window.ShopifyCustomer.id) {
      var guestData = localStorage.getItem(GUEST_KEY);
      if (guestData) {
        try {
          var guestItems = JSON.parse(guestData);
          if (Array.isArray(guestItems) && guestItems.length > 0) {
            var customerKey = getStorageKey();
            var customerData = localStorage.getItem(customerKey);
            var customerItems = customerData ? JSON.parse(customerData) : [];
            if (!Array.isArray(customerItems)) customerItems = [];

            // Merge avoiding duplicates
            guestItems.forEach(function(item) {
              var exists = customerItems.some(function(ci) {
                return String(ci.id) === String(item.id);
              });
              if (!exists) {
                customerItems.push(item);
              }
            });

            localStorage.setItem(customerKey, JSON.stringify(customerItems));
          }
        } catch (e) {
          console.error('[Wishlist] Error migrating guest items:', e);
        }
        // Clear guest key after migration
        localStorage.removeItem(GUEST_KEY);
      }
    }
  }

  // Retrieve current wishlist items array
  function getWishlist() {
    migrateGuestWishlist();
    var key = getStorageKey();
    try {
      var data = localStorage.getItem(key);
      return data ? JSON.parse(data) : [];
    } catch (e) {
      console.error('[Wishlist] Error reading wishlist storage:', e);
      return [];
    }
  }

  // Save wishlist items array to localStorage and notify subscribers
  function saveWishlist(items) {
    var key = getStorageKey();
    try {
      localStorage.setItem(key, JSON.stringify(items));
    } catch (e) {
      console.error('[Wishlist] Error saving wishlist storage:', e);
    }
    notifyWishlistChange(items);
  }

  // Check if product is in wishlist
  function isInWishlist(productId) {
    var items = getWishlist();
    return items.some(function(item) {
      return String(item.id) === String(productId);
    });
  }

  // Toggle item in wishlist (add if missing, remove if present)
  function toggleWishlist(productData) {
    if (!productData || !productData.id) return false;
    var items = getWishlist();
    var productIdStr = String(productData.id);
    var index = -1;

    for (var i = 0; i < items.length; i++) {
      if (String(items[i].id) === productIdStr) {
        index = i;
        break;
      }
    }

    var added = false;
    if (index > -1) {
      items.splice(index, 1);
      added = false;
    } else {
      items.push({
        id: String(productData.id),
        handle: productData.handle || '',
        title: productData.title || '',
        price: Number(productData.price) || 0,
        compare_at_price: Number(productData.compare_at_price) || 0,
        image: productData.image || '',
        url: productData.url || '',
        variant_id: String(productData.variant_id || ''),
        available: productData.available === true || productData.available === 'true',
        variants_count: Number(productData.variants_count) || 1
      });
      added = true;
    }

    saveWishlist(items);

    if (window.showToast) {
      if (added) {
        window.showToast('Item added to wishlist', 'wishlist-add');
      } else {
        window.showToast('Item removed from wishlist', 'wishlist-remove');
      }
    }

    return added;
  }

  // Broadcast wishlist update event
  function notifyWishlistChange(items) {
    var wishlist = items || getWishlist();
    var event = new CustomEvent('wishlist:updated', { detail: { wishlist: wishlist } });
    window.dispatchEvent(event);
    document.dispatchEvent(event);
  }

  // Format currency helper
  function formatMoney(cents) {
    if (typeof cents !== 'number' && typeof cents !== 'string') return '';
    var num = Number(cents);
    if (isNaN(num)) return cents;

    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(num);
    }
    // Fallback format
    var amount = (num / 100).toFixed(2);
    return '₹' + amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  // Update all wishlist buttons on the DOM
  function updateButtons(wishlistItems) {
    var items = wishlistItems || getWishlist();
    var wishlistIds = items.map(function(item) { return String(item.id); });

    document.querySelectorAll('[data-wishlist-btn]').forEach(function(btn) {
      var pid = String(btn.getAttribute('data-product-id'));
      var isSaved = wishlistIds.indexOf(pid) > -1;

      if (isSaved) {
        btn.classList.add('active', 'is-in-wishlist');
        btn.setAttribute('aria-label', 'Remove from Wishlist');
        btn.setAttribute('title', 'Remove from Wishlist');
      } else {
        btn.classList.remove('active', 'is-in-wishlist');
        btn.setAttribute('aria-label', 'Add to Wishlist');
        btn.setAttribute('title', 'Add to Wishlist');
      }
    });
  }

  // Update header count bubble
  function updateHeaderCount(wishlistItems) {
    var items = wishlistItems || getWishlist();
    var count = items.length;

    document.querySelectorAll('.wishlist-count-bubble').forEach(function(bubble) {
      var countSpan = bubble.querySelector('[data-wishlist-count]') || bubble.querySelector('span');
      if (countSpan) {
        countSpan.textContent = count;
      }
      if (count > 0) {
        bubble.classList.remove('hidden');
        bubble.removeAttribute('hidden');

        // Trigger pop animation
        bubble.classList.remove('badge-pop');
        void bubble.offsetWidth; // force reflow
        bubble.classList.add('badge-pop');
      } else {
        bubble.classList.add('hidden');
      }
    });
  }

  // Ensure Wishlist Page container exists if on /pages/wishlist route
  function ensureWishlistPageContainer() {
    var container = document.getElementById('wishlist-grid-container');
    var isWishlistPath = window.location.pathname.indexOf('/pages/wishlist') > -1 || window.location.search.indexOf('view=wishlist') > -1;

    if (!container && isWishlistPath) {
      var mainContent = document.getElementById('MainContent') || document.querySelector('main') || document.body;
      if (mainContent) {
        var wrapper = document.createElement('div');
        wrapper.className = 'wishlist-section page-width';
        wrapper.innerHTML = [
          '<div class="wishlist-header">',
            '<h1 class="wishlist-header__title">My Wishlist</h1>',
            '<p class="wishlist-header__subtitle">Keep track of your favorite baby essentials</p>',
          '</div>',
          '<div id="wishlist-grid-container" class="wishlist-grid-container"></div>'
        ].join('');
        
        mainContent.innerHTML = '';
        mainContent.appendChild(wrapper);
        container = document.getElementById('wishlist-grid-container');
      }
    }
    return container;
  }

  // Render Wishlist Page Grid
  function renderWishlistPage(wishlistItems) {
    var container = ensureWishlistPageContainer();
    if (!container) return;

    var items = wishlistItems || getWishlist();

    if (items.length === 0) {
      container.innerHTML = [
        '<div class="wishlist-empty">',
          '<div class="wishlist-empty__icon-wrapper">',
            '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">',
              '<path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l8.78-8.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>',
            '</svg>',
          '</div>',
          '<h2 class="wishlist-empty__title">Your Wishlist is Empty</h2>',
          '<p class="wishlist-empty__description">You haven\'t saved any items to your wishlist yet. Explore our collection and save your favorite baby essentials!</p>',
          '<a href="/collections/all" class="wishlist-empty__btn">Continue Shopping</a>',
        '</div>'
      ].join('');
      return;
    }

    var html = ['<div class="wishlist-grid">'];

    items.forEach(function(item) {
      var isAvailable = item.available !== false;
      var priceHtml = formatMoney(item.price);
      var comparePriceHtml = item.compare_at_price > item.price ? formatMoney(item.compare_at_price) : '';

      html.push(
        '<div class="wishlist-card" data-product-id="' + item.id + '">',
          '<div class="wishlist-card__image-container">',
            '<a href="' + (item.url || '#') + '" class="wishlist-card__image-link">',
              '<img src="' + (item.image || 'https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-image_large.png') + '" alt="' + (item.title || 'Product Image') + '" class="wishlist-card__image" loading="lazy" width="300" height="300">',
            '</a>',
            '<button type="button" class="wishlist-card__remove-btn" data-wishlist-remove="' + item.id + '" aria-label="Remove item" title="Remove from Wishlist">',
              '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>',
            '</button>',
          '</div>',
          '<div class="wishlist-card__content">',
            '<a href="' + (item.url || '#') + '" class="wishlist-card__title">' + (item.title || 'Product') + '</a>',
            '<div class="wishlist-card__price-row">',
              '<span class="wishlist-card__price">' + priceHtml + '</span>',
              comparePriceHtml ? '<span class="wishlist-card__compare-price">' + comparePriceHtml + '</span>' : '',
            '</div>',
            '<div>',
              isAvailable ? '<span class="wishlist-card__stock-badge wishlist-card__stock-badge--in-stock">In Stock</span>' : '<span class="wishlist-card__stock-badge wishlist-card__stock-badge--sold-out">Sold Out</span>',
            '</div>',
            '<div class="wishlist-card__actions">',
              isAvailable ? (
                '<button type="button" class="wishlist-card__add-btn" data-wishlist-add-cart="' + item.variant_id + '">Add to Cart</button>'
              ) : (
                '<button type="button" class="wishlist-card__add-btn" disabled>Sold Out</button>'
              ),
            '</div>',
          '</div>',
        '</div>'
      );
    });

    html.push('</div>');
    container.innerHTML = html.join('');
  }

  // Handle click delegation (using capture phase to intercept card links)
  function initEventDelegation() {
    document.addEventListener('click', function(e) {
      // 1. Wishlist Button Click (Add/Remove toggle)
      var wishlistBtn = e.target.closest('[data-wishlist-btn]');
      if (wishlistBtn) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        var productData = {
          id: wishlistBtn.getAttribute('data-product-id'),
          handle: wishlistBtn.getAttribute('data-product-handle'),
          title: wishlistBtn.getAttribute('data-product-title'),
          price: wishlistBtn.getAttribute('data-product-price'),
          compare_at_price: wishlistBtn.getAttribute('data-product-compare-price'),
          image: wishlistBtn.getAttribute('data-product-image'),
          url: wishlistBtn.getAttribute('data-product-url'),
          variant_id: wishlistBtn.getAttribute('data-variant-id'),
          available: wishlistBtn.getAttribute('data-available'),
          variants_count: wishlistBtn.getAttribute('data-variants-count')
        };

        wishlistBtn.classList.add('wishlist-animating');
        setTimeout(function() {
          wishlistBtn.classList.remove('wishlist-animating');
        }, 500);

        toggleWishlist(productData);
        return false;
      }

      // 2. Wishlist Page Remove Button Click
      var removeBtn = e.target.closest('[data-wishlist-remove]');
      if (removeBtn) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        var pid = removeBtn.getAttribute('data-wishlist-remove');
        var card = removeBtn.closest('.wishlist-card');
        if (card) {
          card.classList.add('removing');
          setTimeout(function() {
            toggleWishlist({ id: pid });
          }, 250);
        } else {
          toggleWishlist({ id: pid });
        }
        return false;
      }

      // 3. Wishlist Page Add to Cart Button Click
      var addCartBtn = e.target.closest('[data-wishlist-add-cart]');
      if (addCartBtn && !addCartBtn.disabled) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        var variantId = addCartBtn.getAttribute('data-wishlist-add-cart');
        if (!variantId) return false;

        var originalText = addCartBtn.textContent;
        addCartBtn.textContent = 'Adding...';
        addCartBtn.disabled = true;

        var formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', 1);

        var cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
          formData.append(
            'sections',
            cartDrawer.getSectionsToRender().map(function(section) { return section.id; }).join(',')
          );
          formData.append('sections_url', window.location.pathname);
        }

        fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        })
        .then(function(res) { return res.json(); })
        .then(function(data) {
          addCartBtn.textContent = (window.innerWidth <= 749) ? 'Cart ✓' : 'Added ✓';
          if (window.showToast) window.showToast('Item added to cart', 'cart');
          setTimeout(function() {
            addCartBtn.textContent = originalText;
            addCartBtn.disabled = false;
          }, 2000);

          fetch('/cart.js')
            .then(function(r) { return r.json(); })
            .then(function(cart) {
              if (window.updateCartCounters) window.updateCartCounters(cart);
              if (window.syncCardButtonsWithCart) window.syncCardButtonsWithCart(cart);
            });

          if (cartDrawer && data && data.sections && data.sections['cart-drawer']) {
            cartDrawer.renderContents(data);
          } else if (cartDrawer && typeof cartDrawer.open === 'function') {
            cartDrawer.open();
          }
        })
        .catch(function(err) {
          console.error('[Wishlist] Error adding to cart:', err);
          addCartBtn.textContent = originalText;
          addCartBtn.disabled = false;
        });
        return false;
      }
    }, true); // useCapture = true
  }

  // Synchronize UI on wishlist update
  function syncUI(e) {
    var items = e && e.detail && e.detail.wishlist ? e.detail.wishlist : getWishlist();
    updateButtons(items);
    updateHeaderCount(items);
    renderWishlistPage(items);
  }

  // Initialize engine
  function init() {
    initEventDelegation();

    // Listen to custom wishlist updates
    window.addEventListener('wishlist:updated', syncUI);
    document.addEventListener('wishlist:updated', syncUI);

    // Listen to storage changes across tabs
    window.addEventListener('storage', function(e) {
      if (e.key === getStorageKey() || e.key === GUEST_KEY) {
        syncUI();
      }
    });

    // Initial render
    syncUI();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Expose API on window object
  window.BabyTomsWishlist = {
    get: getWishlist,
    toggle: toggleWishlist,
    isInWishlist: isInWishlist,
    sync: syncUI
  };

})();
